import {useMemo} from "react";

import SimpleMarkdown, {
    type Parser,
    type ReactOutput,
} from "@khanacademy/simple-markdown";

import defaultRules from "./rules/default-rules.ts";
import type {MarkdownRules} from "./types.ts";

/**
 * useMarkdownRenderer returns a Markdown parser and an output function for a
 * given set of markdown rules.
 */
const useMarkdownRenderer = (
    rules: MarkdownRules = defaultRules,
): {
    parse: Parser;
    render: ReactOutput;
} => {
    const render: ReactOutput = useMemo(
        () => SimpleMarkdown.outputFor(rules, "react"),
        [rules],
    );
    const parse = useMemo(() => {
        const _rawParse: Parser = SimpleMarkdown.parserFor(rules);
        return (source: string) => {
            const blockSource = source + "\n\n";
            return _rawParse(blockSource, {inline: false});
        };
    }, [rules]);

    return useMemo(
        () => ({
            parse,
            render,
        }),
        [parse, render],
    );
};

export default useMarkdownRenderer;
